module.exports = __webpack_public_path__ + "static/media/work.98ee7a92.jpg";